import { guestGuard } from 'src/router/guards/guest'
import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/AuthTenant.vue'),
    beforeEnter: [guestGuard],
    meta: {
      omitLayout: true,
    },
  },
]

export default routes
